const REVIEWED_VISIT_STATUSES = new Set(['approved', 'rejected', 'flagged']);

/** Returns true when any visit on the case has been reviewed by an admin. */
export function caseHasReviewedVisit(visits: { status?: string }[]): boolean {
    return visits.some((visit) =>
        REVIEWED_VISIT_STATUSES.has((visit.status ?? '').toLowerCase()),
    );
}

/** Returns true when the case can be edited (no reviewed visits). */
export function isCaseEditable(visits: { status?: string }[]): boolean {
    return !caseHasReviewedVisit(visits);
}
